import PropTypes from 'prop-types';

import styles from './TimeSlotSectionTitle.scss';

export const TimeSlotSectionTitle = ({ section: { id: sectionName }, isDisabled }) => (
  <span
    data-testid={isDisabled ? 'unavailable' : 'available'}
    className={`${styles.TimeSlotSectionTitle} ${isDisabled ? styles.TimeSlotSectionTitle__disabled : ''}`}
  >
    {sectionName}
    {isDisabled && (
      <svg width="100%" height="100%">
        <line y2="0" x2="100%" y1="100%" x1="0" strokeWidth="1" fill="none" />
      </svg>
    )}
  </span>
);

TimeSlotSectionTitle.propTypes = {
  section: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  isDisabled: PropTypes.bool.isRequired,
};
